import React from 'react';
//import PropTypes from 'prop-types';

const SearchBox = ({value, onChange, fullWidth, logSearch, ...rest}) => {

    return (
        <div className='search subscribers-search'>
            <span className='fas fa-search'></span>
            <input
                className={fullWidth === true ? 'full-width' : ''}
                name="query"
                placeholder="Search"
                id='subs-search'
                type="text"
                onBlur={logSearch}
                onFocus={logSearch}
                onChange={e => onChange(e.currentTarget.value)}
                {...rest}/>

        </div>
    );
};


//Input.propTypes = {
//    name: PropTypes.number.isRequired,
//    pageSize: PropTypes.number.isRequired,
//    currentPage: PropTypes.number.isRequired,
//    onPageChange: PropTypes.func.isRequired
//};

export default SearchBox;
